module.exports = __webpack_public_path__ + "static/devteam_02-dc71daed6c850dfc7b65e22bb691d1bb.jpg";